export const detectPhoneNumberCode = (phoneNumber) => {
    const patterns = {
        '^7': 0,
        '^375': 1,
        '^994': 2,
    };

    const pattern = Object.keys(patterns).find((p) => new RegExp(p).test(phoneNumber));
    return pattern ? config.transportNumberOptions[patterns[pattern]].code : null;
};
